import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import TenantSidebar from './TenantSidebar';
import { cn } from '../../lib/utils';
import { Toaster } from '../ui/sonner';
import { Menu } from 'lucide-react';
import { Button } from '../ui/button';
import { ChangePasswordModal } from '../auth/ChangePasswordModal';

export const TenantLayout = () => {
  const { mustChangePassword } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <ChangePasswordModal open={mustChangePassword} />
      {mobileOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/50 lg:hidden"
          onClick={() => setMobileOpen(false)}
          data-testid="tenant-mobile-overlay"
        />
      )}

      <div className={cn('lg:block', mobileOpen ? 'block' : 'hidden')}>
        <TenantSidebar
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
          onClose={() => setMobileOpen(false)}
        />
      </div>

      <main
        className={cn(
          'min-h-screen transition-all duration-300',
          'lg:ml-64',
          sidebarCollapsed && 'lg:ml-16',
          'ml-0',
        )}
      >
        <div className="sticky top-0 z-20 flex items-center gap-3 px-4 py-3 bg-white border-b border-slate-200 lg:hidden safe-top">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setMobileOpen(true)}
            className="text-slate-700 shrink-0"
            data-testid="tenant-mobile-menu-btn"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="font-manrope font-bold text-slate-900 truncate">Domio</span>
        </div>

        <div className="p-4 sm:p-6 md:p-8 max-w-full overflow-x-hidden safe-bottom">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default TenantLayout;
